import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";

function ThankYou() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  // <----- logic to fetch order details ----->
  useEffect(() => {
    const details = localStorage.getItem("Details");
    if (details) {
      const parsedDetails = JSON.parse(details);
      setData(parsedDetails);
      setLoading(false);
      localStorage.removeItem("Details");
    }
  }, []);

  return (
    <div className={`app-content page-container${loading ? " -page-loading" : ""}`}>
      <Header />

      <main id="maincontent" aria-label="Page Content">
        <div className="grid-container">
          {loading ? (
            <div className="g-col-main">
              <div className="payment-grid-card-body asce-loader -loading">
                <div className="asce-loader-text">Loading content... We appreciate your patience</div>
              </div>
            </div>
          ) : (
            <div className="payment-complete">
              <div className="payment-complete-inner">
                <div className="payment-complete-card">
                  <h1 className="eyebrow">Payment complete</h1>
                  <h2>Thank you, {data.orderDetails.billCustomerName}!</h2>
                  <p>
                    Your payment for Order <strong>#{data.responseValue.orderNumbers}</strong> has been successfully processed. Your receipt number is{" "}
                    <strong>{data.responseValue.receiptNumber}</strong>.
                  </p>
                  <ul className="payment-complete-list">
                    <li id="items">
                      <ul>
                        {data.orderDetails.details && data.orderDetails.details.length > 0
                          ? data.orderDetails.details.map((item, index) => (
                              <li key={index} className="payment-complete-item">
                                <div className="payment-complete-item-name">
                                  <strong>{item.description}</strong>
                                </div>
                                <div className="payment-complete-item-amount">${Number(item.actualtotalamount).toFixed(2)}</div>
                              </li>
                            ))
                          : null}
                      </ul>
                    </li>
                    <li id="total" className="payment-complete-total">
                      <div className="payment-complete-total-name">
                        <span>Total</span>
                      </div>
                      <div className="payment-complete-total-amount">
                        <strong>${Number(data.orderDetails.ordertotalbalanceamount).toFixed(2)}</strong>
                      </div>
                    </li>
                  </ul>
                  <div className="messages messages--warning mt-4" role="alert" aria-label="Warning message">
                    <strong>Important:</strong> You will <em>not</em> receive an email confirmation after completing your payment. Please{" "}
                    <strong>save or print this confirmation receipt</strong> now and keep it for your records.
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ThankYou;
